import React, { useMemo } from "react";
import { CONSTANTS } from "../data";
import { Trophy } from "lucide-react";

interface ActiveChallengeBarProps {
  masterChefChallenge: any;
}

const ActiveChallengeBar: React.FC<ActiveChallengeBarProps> = ({ masterChefChallenge }) => {
  const challengeDef = useMemo(() => {
    if (!masterChefChallenge.active || !masterChefChallenge.id) return null;
    return CONSTANTS.MASTER_CHEF_CHALLENGES[masterChefChallenge.id];
  }, [masterChefChallenge]);

  if (!masterChefChallenge.active || !challengeDef) return null;

  const progress = Math.min(
    1,
    masterChefChallenge.goal > 0
      ? masterChefChallenge.progress / masterChefChallenge.goal
      : 0
  );

  return (
    <div className="w-full bg-blue-500 text-white py-2 px-4 flex items-center gap-4 text-sm">
      <Trophy size={18} className="flex-shrink-0" />
      <span className="font-bold flex-shrink-0">
        {challengeDef.name}
      </span>
      <div className="flex-1 flex items-center gap-2">
        <div className="w-full bg-black/20 rounded-full h-2.5 relative">
          <div
            className="bg-white h-2.5 rounded-full transition-all duration-300"
            style={{ width: `${progress * 100}%` }}
          />
        </div>
        <span className="text-xs font-mono">
          {masterChefChallenge.progress}/{masterChefChallenge.goal}
        </span>
      </div>
    </div>
  );
};

export default ActiveChallengeBar;
